import * as z from "zod";

import { REQUIRED_MESSAGE } from "components/form/utils";

const employeeObject = () =>
  z
    .object({
      id: z.string(),
    })
    .or(z.literal(undefined))
    .or(z.literal(null))
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export const jobEmployeeSchema = z.object({
  employee: employeeObject(),
  reviewer: employeeObject(),
  is_logging_restricted: z.boolean().default(false),
  is_shadow: z.boolean().default(false),
});
